module.exports = __webpack_public_path__ + "img/b.806d4dee.png";